import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/context/AuthContext';
import { LanguageProvider } from '@/context/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SupportButton from '@/components/SupportButton';

// Pages
import Home from '@/pages/Home';
import VisaApplication from '@/pages/VisaApplication';
import TrackApplication from '@/pages/TrackApplication';
import Payment from '@/pages/Payment';
import PaymentSuccess from '@/pages/PaymentSuccess';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminApp from '@/pages/AdminApp';

// B2B Pages
import B2BLogin from '@/pages/B2BLogin';
import B2BDashboard from '@/pages/B2BDashboard';
import B2BApplicationNew from '@/pages/B2BApplicationNew';
import B2BAddCredit from '@/pages/B2BAddCredit';
import B2BTopupSuccess from '@/pages/B2BTopupSuccess';

import '@/App.css';

// Layout wrapper to conditionally show navbar/footer
const AppLayout = ({ children }) => {
  const location = useLocation();
  const isB2BRoute = location.pathname.startsWith('/b2b-agent');
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  const hideNavFooter = isB2BRoute || isAdminRoute;
  
  return (
    <div className="App min-h-screen flex flex-col">
      {!hideNavFooter && <Navbar />}
      <main className="flex-1">
        {children}
      </main>
      {!hideNavFooter && <Footer />}
      {!isB2BRoute && !isAdminRoute && <SupportButton />}
      <Toaster position="top-right" richColors />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppLayout>
            <Routes>
              {/* B2C Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/apply" element={<VisaApplication />} />
              <Route path="/track" element={<TrackApplication />} />
              <Route path="/payment/:applicationId" element={<Payment />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/app" element={<AdminApp />} />
              <Route path="/admin/app/*" element={<AdminApp />} />
              
              {/* B2B Agent Routes */}
              <Route path="/b2b-agent" element={<B2BLogin />} />
              <Route path="/b2b-agent/dashboard" element={<B2BDashboard />} />
              <Route path="/b2b-agent/new-application" element={<B2BApplicationNew />} />
              <Route path="/b2b-agent/apply" element={<B2BApplicationNew />} />
              <Route path="/b2b-agent/add-credit" element={<B2BAddCredit />} />
              <Route path="/b2b-agent/topup-success" element={<B2BTopupSuccess />} />
            </Routes>
          </AppLayout>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;